// Toast (§11.5): "Pasted to N photos" with Undo (restores every pasted photo at once).
import { useEffect } from 'react';
import { useClipboard } from '../../state/clipboard';
import { useEditor } from '../../state/editor';
import { useT } from '../../i18n';

export function Toast() {
  const t = useT();
  const toast = useClipboard((st) => st.toast);
  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(() => useClipboard.getState().setToast(null), toast.undo ? 8000 : 2500);
    return () => clearTimeout(id);
  }, [toast]);
  if (!toast) return null;
  const text = t(toast.key, toast.vars);
  return (
    <div
      role="status"
      data-testid="toast"
      style={{
        position: 'fixed',
        left: '50%',
        bottom: 140,
        transform: 'translateX(-50%)',
        zIndex: 90,
        display: 'flex',
        gap: 12,
        alignItems: 'center',
        padding: '8px 14px',
        background: '#1f1f1f',
        border: '1px solid var(--line)',
        borderRadius: 6,
      }}
    >
      <span>{text}</span>
      {toast.undo && (
        <button
          data-testid="toast-undo"
          onClick={() => {
            useEditor.getState().restoreMany(toast.undo!.before);
            useClipboard.getState().setToast(null);
          }}
        >
          {toast.key === 'pastedN' ? t('undoPasteN', { n: toast.undo.n }) : t('undo')}
        </button>
      )}
    </div>
  );
}
